import {HTTP} from '../../../services/api-service.js';
import commonObj from '../../../services/common.js';
var common = new commonObj();
var baseUrl = common.baseURL;

const invoicePrintingStore = {
    namespaced: true,
    state:{
        searchModel:{
            compCode:"",
            DateFrom: "",
            DateTo: "",
            DateTxFrom:"",
            DateTxTo:"",     
            DateDeliveryFrom:"",
            DateDeliveryTo:"",        
            EntNum:"",           
            TxNumFrom:"",
            TxNumTo:"",
            isPosted: false,
            newOnly: false  ,
            InclAIedTx: true,         
        }
    },
    actions:{     
        getPrintInvoiceList({commit,state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/invoice/getprintinvlist', param).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },  
        printInvoiceList({commit,state}, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/invoice/printinvs20191201', { printInvoiceList: param.printInvoiceList, rptID: param.rptID, updPrtStatus: param.updPrtStatus } , {responseType : 'blob'}).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },  
        printPickingList({commit,state}, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/invoice/printpls', { printPickingList: param.printInvoiceList, rptID: param.rptID } , {responseType : 'blob'}).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        }        
    }
};
export default invoicePrintingStore;